import React from 'react'
import "../../scss/error.scss";

const Error = () => {
  return (
    <div className='show-error-report'>
      <p>Error. Please input correct credentials!!</p>
    </div>
  )
}

export default Error
